export const priceToString = (price, currency) => {
  switch (currency) {
    case 'USD':
      return '$' + price;
    case 'CAD':
    default:
      return price + currency;
  }
}